import {createContext} from 'react';

const HostContext = createContext();

export default HostContext;
